import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useChat } from '../context/ChatContext';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Chat.css';
import supportLogo from '../assets/logo_q.png';
const API_URL = process.env.REACT_APP_API_URL;
// İsimlere göre tutarlı renkler üreten yardımcı fonksiyon
const nameToColor = (name) => {
    if (!name) return '#bdc3c7';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#e67e22', '#e74c3c', '#f1c40f'];
    return colors[Math.abs(hash) % colors.length];
};

// --- ALT BİLEŞEN 1: Mesajlaşma Arayüzü ---
const UserChatView = ({ conversationHeader }) => {
    const { messages, loadingMessages, sendMessage, chatContext, fetchMessages } = useChat(); 
    const { user, token } = useAuth();
    const { t } = useTranslation();
    
    const [newMessage, setNewMessage] = useState('');
    const [editingMessage, setEditingMessage] = useState(null);
    const [editedContent, setEditedContent] = useState('');
    const messagesEndRef = useRef(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const handleSend = (e) => {
        e.preventDefault();
        if (newMessage.trim()) { sendMessage(newMessage); setNewMessage(''); }
    };
    
    const handleFileUpload = async (file) => {
        if (!file || !chatContext.jobId) return;
        const formData = new FormData();
        formData.append('attachment', file);
        try {
            const response = await fetch(`${API_URL}/api/chat/conversations/${chatContext.jobId}/upload`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: formData
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(t(errorData.messageKey) || t('error_file_upload'));
            }
            // fetchMessages(chatContext.jobId); // Socket halledeceği için gereksiz
        } catch (err) {
            alert(err.message);
        }
    };

    const startEditing = (message) => {
        setEditingMessage(message);
        setEditedContent(message.content);
    };
    
    const saveEdit = async () => {
        if (!editingMessage || editedContent.trim() === '') return;
        try {
            const response = await fetch(`${API_URL}/api/chat/messages/${editingMessage.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ newContent: editedContent })
            });
            if (!response.ok) throw new Error(t('error_message_edit'));
            setEditingMessage(null);
        } catch (err) {
            alert(err.message);
        }
    };
if (!user) {
        return <div className="chat-loader">{t('loading')}</div>;
    }
   return (
        <>
           {conversationHeader && (
                <div className="chat-conversation-header">
                    <button onClick={conversationHeader.onBack} className="back-to-list-btn">
                        <i className="fas fa-arrow-left"></i>
                    </button>
                    <div className="conversation-header-info">
                        <span>{conversationHeader.customerName}</span>
                        <Link to={`/management/jobs/${conversationHeader.jobId.split('#')[1]}`} className="job-link-in-chat">
                            {conversationHeader.jobId}
                        </Link>
                    </div>
                </div>
            )}
			
          <main className="chat-messages">
                {loadingMessages && <div className="chat-loader">{t('loading_messages')}</div>}
                {!loadingMessages && messages && messages.map(msg => {
                    // DÜZELTME: Değişken tanımı, map döngüsünün hemen içine, return'den önceye taşındı.
                    const bubbleClass = msg.sender_id === user.id ? 'me' : 'other';
                    
                   if (msg.message_type === 'system') {
                    // DÜZELTME: Gelen JSON string'ini ayrıştır
                    let messageText = msg.content;
                    try {
                        const parsedContent = JSON.parse(msg.content);
                        // Çeviriyi, gelen anahtar ve parametrelerle yap
                        messageText = t(parsedContent.key, parsedContent.params);
                    } catch (e) {
                        // Eğer ayrıştırma başarısız olursa, eski usul devam et
                        messageText = t(msg.content);
                    }
                        return (
                            <div key={msg.id} className="message-bubble system">
                                <i className="fas fa-info-circle"></i> {t(msg.content)}
                            </div>
                        );
                    }
                    return (
                        <div key={msg.id} className={`message-bubble ${bubbleClass}`}>
                            {editingMessage && editingMessage.id === msg.id ? (
                                <div className="message-editor">
                                    <textarea value={editedContent} onChange={(e) => setEditedContent(e.target.value)} autoFocus />
                                    <div className="editor-buttons">
                                        <button onClick={saveEdit} className="editor-save">{t('save')}</button>
                                        <button onClick={() => setEditingMessage(null)} className="editor-cancel">{t('cancel')}</button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {msg.sender_id !== user.id && <span className="sender-name">{msg.sender_name}</span>}
                                    {msg.message_type === 'image' ? (<a href={`${API_URL}/${msg.attachment_url}`} target="_blank" rel="noopener noreferrer"><img src={`${API_URL}/${msg.attachment_url}`} alt={msg.content} className="chat-image" /></a>) : 
                                     msg.message_type === 'file' ? (<a href={`${API_URL}/${msg.attachment_url}`} download={msg.content} className="chat-file-link"><i className="fas fa-file-alt"></i> {msg.content}</a>) : 
                                     (<p className="message-content">{msg.content}</p>)}
                                    {['support', 'admin'].includes(user.role) && msg.sender_id === user.id && msg.message_type === 'text' && (
                                        <button onClick={() => startEditing(msg)} className="edit-btn" title={t('edit')}><i className="fas fa-pencil-alt"></i></button>
                                    )}
                                </>
                            )}
                        </div>
                    );
                })}
                <div ref={messagesEndRef} />
            </main>
            <footer className="chat-footer">
                <input type="file" id={`chat-file-upload-${chatContext.jobId}`} style={{display: 'none'}} ref={fileInputRef} onChange={(e) => handleFileUpload(e.target.files[0])} />
                <button onClick={() => fileInputRef.current.click()} className="attach-btn" title={t('attach_file')}><i className="fas fa-paperclip"></i></button>
                <form onSubmit={handleSend} className="message-form">
                    <input type="text" value={newMessage} onChange={(e) => setNewMessage(e.target.value)} placeholder={t('chat_placeholder')} />
                    <button type="submit" className="send-btn" title={t('send')}><i className="fas fa-paper-plane"></i></button>
                </form>
            </footer>
        </>
    );
};

// --- ALT BİLEŞEN 2: Destek Ekibinin Ana Sohbet Arayüzü ---

const SupportChatView = ({ onConversationSelect }) => {
    const { t } = useTranslation();
    const { token } = useAuth();
    const { openChat } = useChat();  
    
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState('active');
    const [selectedConversation, setSelectedConversation] = useState(null);
 const [searchTerm, setSearchTerm] = useState('');
 
  // YENİ: Arama terimine göre sohbetleri filtrele
    const filteredConversations = useMemo(() => {
        if (!searchTerm) {
            return conversations;
        }
        const lowerCaseSearch = searchTerm.toLowerCase();
        return conversations.filter(convo => {
                   const displayName = convo.translator_first_name 
                        ? `${convo.translator_first_name} ${convo.translator_last_name}`
                        : `${convo.customer_first_name} ${convo.customer_last_name}`;
            return (
                displayName.toLowerCase().includes(lowerCaseSearch) ||
                convo.job_id.toString().includes(lowerCaseSearch)
            );
        });
    }, [conversations, searchTerm]);
	
    const fetchConversations = useCallback(async (status) => {
        if (!token) return;
        try {
            setLoading(true); setError('');
            const response = await fetch(`${API_URL}/api/support/conversations?status=${status}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error(t('error_fetch_conversations'));
            const data = await response.json();
            setConversations(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [token, t]);

    useEffect(() => {
        fetchConversations(activeTab);
    }, [fetchConversations, activeTab]);

    const handleArchiveToggle = async (jobId, shouldArchive) => {
        try {
            await fetch(`${API_URL}/api/support/conversations/${jobId}/archive`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ archive: shouldArchive })
            });
            setConversations(prev => prev.filter(c => c.job_id !== jobId));
        } catch (err) {
            alert('İşlem başarısız oldu.');
        }
    };

    const handleConversationClick = (conversation) => {
        openChat({
            jobId: conversation.job_id,
            recipientName: `${conversation.translator_name || conversation.customer_name || t('unassigned')}`
        });
        setSelectedConversation(conversation);
    };

     const handleBackToList = () => {
        openChat({ recipientName: t('inbox') });
        setSelectedConversation(null);
        fetchConversations(activeTab); // Listeyi yenile
    };

    if (selectedConversation) {
       

          const headerData = {
             customerName: t('chat_header_customer', { 
                firstName: selectedConversation.customer_first_name, 
                lastName: selectedConversation.customer_last_name 
            }),
            jobId: t('chat_header_job', { id: selectedConversation.job_id }),
            onBack: handleBackToList
        };
        return ( <UserChatView conversationHeader={headerData} /> );
    }
   
   return (
        <div className="support-chat-view">
            {/* DÜZELTME: Sekmeler ve arama çubuğu artık aynı konteyner içinde */}
            <div className="support-chat-header">
                <div className="support-chat-tabs">
                    <button onClick={() => setActiveTab('active')} className={activeTab === 'active' ? 'active' : ''}>{t('inbox')}</button>
                    <button onClick={() => setActiveTab('archived')} className={activeTab === 'archived' ? 'active' : ''}>{t('archived')}</button>
                </div>
                <div className="chat-search-bar">
                    <i className="fas fa-search"></i>
                    <input 
                        type="text" 
                        placeholder={t('chat_search_placeholder')}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>
            <ul className="contact-list">
                {loading && <li className="chat-loader"><i className="fas fa-spinner fa-spin"></i> {t('loading')}</li>}
                {error && <li className="chat-error">{error}</li>}
                {/* DÜZELTME: artık 'filteredConversations' kullanılıyor */}
                {!loading && filteredConversations.length === 0 && <li className="chat-info">{searchTerm ? t('no_conversations_found_for_search') : t('no_active_conversations')}</li>}
                {!loading && filteredConversations.map(convo => {
                    const displayName = convo.translator_first_name 
                        ? `${convo.translator_first_name} ${convo.translator_last_name}`
                        : `${convo.customer_first_name} ${convo.customer_last_name}`;
                    return (
                        <li key={convo.job_id} className={convo.unread_messages > 0 ? 'unread' : ''} onClick={() => onConversationSelect(convo)}>
                           <div className="contact-main">
                <div className="contact-avatar" style={{ backgroundColor: nameToColor(displayName) }}>{displayName.charAt(0).toUpperCase()}</div>
                <div className="contact-info">
                    <span className="contact-name">{displayName}</span>
                    <span className="contact-job">#{convo.job_id}</span>
                </div>
            </div>

                            <div className="contact-actions">
                                {convo.unread_messages > 0 && (<span className="unread-badge">{convo.unread_messages}</span>)}
                                <button onClick={(e) => { e.stopPropagation(); handleArchiveToggle(convo.job_id, activeTab === 'active'); }} className="archive-btn" title={activeTab === 'active' ? t('archive') : t('unarchive')}>
                                    <i className={`fas ${activeTab === 'active' ? 'fa-box-archive' : 'fa-inbox'}`}></i>
                                </button>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
// --- ALT BİLEŞEN 3: ÇEVİRMENİN ANA SOHBET LİSTESİ GÖRÜNÜMÜ ---
const TranslatorChatView = ({ onConversationSelect }) => {
    const { t } = useTranslation();
    const { token } = useAuth();
    
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
const [activeTab, setActiveTab] = useState('active');
const fetchConversations = useCallback(async (status) => {
        if (!token) return;
        try {
            setLoading(true); setError('');
            // YENİ: API isteği artık status parametresini içeriyor
            const response = await fetch(`${API_URL}/api/dashboard/conversations?status=${status}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error(t('error_fetch_conversations'));
            const data = await response.json();
            setConversations(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [token, t]);

    useEffect(() => {
        fetchConversations(activeTab);
    }, [fetchConversations, activeTab]);
    
    // YENİ: İçeriği render eden yardımcı fonksiyon
    const renderList = () => {
        if (loading) {
            return <li className="chat-loader"><i className="fas fa-spinner fa-spin"></i> {t('loading')}</li>;
        }
        if (error) {
            return <li className="chat-error">{error}</li>;
        }
        if (conversations.length === 0) {
          return <li className="chat-info">{t('no_conversations_in_category', 'Bu kategoride sohbet bulunmamaktadır.')}</li>;
        }
        return conversations.map(convo => (
            <li key={convo.job_id} className={convo.unread_messages > 0 ? 'unread' : ''} onClick={() => onConversationSelect(convo)}>
                <div className="contact-main">
             <div className="contact-avatar logo-avatar">
                        <img src={supportLogo} alt="Support" />
                    </div>
            <div className="contact-info">
                <span className="contact-name">{t('support_team')}</span>
                <span className="contact-job">#{convo.job_id}</span>
            </div>
        </div>
                <div className="contact-actions">
                    {convo.unread_messages > 0 && (<span className="unread-badge">{convo.unread_messages}</span>)}
                </div>
            </li>
        ));
    };

   return (
        <div className="support-chat-view">
           {/* YENİ: Sekmeler */}
           <div className="support-chat-tabs">
                <button onClick={() => setActiveTab('active')} className={activeTab === 'active' ? 'active' : ''}>{t('active_chats', 'Aktif Sohbetler')}</button>
                <button onClick={() => setActiveTab('completed')} className={activeTab === 'completed' ? 'active' : ''}>{t('completed_chats', 'Tamamlananlar')}</button>
            </div>
           <ul className="contact-list">
                {renderList()}
            </ul>
        </div>
    );
};
// --- ANA CHATWIDGET BİLEŞENİ ---

const ChatWidget = () => {
    const { isChatOpen, closeChat, chatContext, openChat, messages } = useChat();
    const { user } = useAuth();
    const { t } = useTranslation();

    const [selectedConversation, setSelectedConversation] = useState(null);

    useEffect(() => {
        if (!user) return;  
		
        if (chatContext.jobId && (!selectedConversation || chatContext.jobId !== selectedConversation.job_id)) {
            // Context'ten gelen jobId'ye göre, tam konuşma verisini bulmamız gerekebilir.
            // Şimdilik, context'in taşıdığı bilgiyi kullanıyoruz.
            setSelectedConversation({ 
                job_id: chatContext.jobId, 
                customer_first_name: chatContext.recipientName?.split(' ')[0],
                customer_last_name: chatContext.recipientName?.split(' ')[1] || '',
                translator_name: user.role === 'customer' ? 'Destek Ekibi' : null
            });
        } else if (!chatContext.jobId) {
            setSelectedConversation(null);
        }
    }, [chatContext, selectedConversation, user]); 

    const handleConversationSelect = (conversation) => {
        setSelectedConversation(conversation);
        openChat({ jobId: conversation.job_id });
    };

    const handleBackToList = () => {
        setSelectedConversation(null);
        openChat({ recipientName: t('messages') });
    };

      if (!isChatOpen || !user) {
        return null;
    }
     const handleExportChat = () => {
        if (messages.length === 0) return;

        let chatLog = `${t('chat_history_for_job')} #${chatContext.jobId}\n`;
        chatLog += `${t('export_date')}: ${new Date().toLocaleString()}\n`;
        chatLog += "--------------------------------------------------\n\n";

        messages.forEach(msg => {
            const timestamp = new Date(msg.created_at).toLocaleString();
            const sender = msg.sender_id === 0 ? t('system') : msg.sender_name;
            let content = msg.content;
            
            if (msg.message_type === 'file' || msg.message_type === 'image') {
                content = `[${t('file')}: ${msg.content}]`;
            }
            if (msg.message_type === 'system') {
                try {
                    const parsed = JSON.parse(msg.content);
                    content = `[${t('system_message')}]: ${t(parsed.key, parsed.params)}`;
                } catch(e) {
                    content = `[${t('system_message')}]: ${t(msg.content)}`;
                }
            }
            chatLog += `[${timestamp}] ${sender}: ${content}\n`;
        });

        const blob = new Blob([chatLog], { type: 'text/plain;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `chat_history_job_${chatContext.jobId}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const isSupportView = user && ['support', 'admin'].includes(user.role);
    const isTranslatorView = user && user.role === 'translator';
    
    const renderView = () => {
        if (selectedConversation) {
            // Artık header bilgisi göndermeye gerek yok
            return <UserChatView />;
        }
        
       if (isSupportView) return <SupportChatView onConversationSelect={handleConversationSelect} />;
        if (isTranslatorView) return <TranslatorChatView onConversationSelect={handleConversationSelect} />;
        
        return <UserChatView conversationHeader={null} />; // Müşteri için
    };
 
    
    // Başlık ve diğer elemanların yönetimini tamamen buraya taşıdık
    let headerTitle;
    if (selectedConversation) {
        if (isSupportView) {
            const isWithTranslator = !!selectedConversation.translator_first_name;
            headerTitle = isWithTranslator 
                ? `${selectedConversation.translator_first_name}` 
                : `${selectedConversation.customer_first_name} ${selectedConversation.customer_last_name}`;
        } else {
            headerTitle = t('support_team');
        }
    } else {
        headerTitle = (isSupportView || isTranslatorView) ? t('messages') : t('support_team');
    }

    return (
        <div className={`chat-widget ${isSupportView || (isTranslatorView && !selectedConversation) ? 'list-view' : ''}`}>
            <header className="chat-header">
                {(isSupportView || isTranslatorView) && selectedConversation && (
                    <button onClick={handleBackToList} className="header-back-btn">
                        <i className="fas fa-arrow-left"></i>
                    </button>
                )}
                <h3>{headerTitle}</h3>
                
                {/* DÜZELTME: Tüm koşullar tek bir blokta birleştirildi */}
                {selectedConversation && (
                    <>
                        {isSupportView ? (
                            <Link to={`/management/jobs/${selectedConversation.job_id}`} className="header-job-link" title={t('view_job_details')}>
                                #{selectedConversation.job_id}
                            </Link>
                        ) : (
                            <span className="header-job-span">
                                #{selectedConversation.job_id}
                            </span>
                        )}
                        
                        {/* Export butonu da aynı koşulun içinde */}
                        {(isSupportView) && (
                            <button onClick={handleExportChat} className="export-chat-btn-header" title={t('export_chat')}>
                                <i className="fas fa-file-export"></i>
                            </button>
                        )}
                    </>
                )}

                <button onClick={closeChat} className="close-btn">&times;</button>
            </header>
            {renderView()}
        </div>
    );
};
 
export default ChatWidget;